import { migrateLegacyRecentlyPlayedGames } from './gaming/stateRehydrate';
import {
    IPreferencesState,
    IPreferencesStateLegacy,
} from './types';

export function stateRehydrate(savedState: IPreferencesState | IPreferencesStateLegacy) {
    return Object.entries(savedState).reduce((acc, [userId, state]) => {
        return {
            ...acc,
            [userId]: {
                ...state,
                recentlyPlayedGames: migrateLegacyRecentlyPlayedGames(state.recentlyPlayedGames),
            },
        };
    }, {} as IPreferencesState);
}
